export const getPhoneNumberLocationLabel = (number: {
    locality?: string | null;
    region?: string | null;
    postalCode?: string | null;
}) => {
    return (
        [number.locality, number.region, number.postalCode]
            .filter(Boolean)
            .join(", ") || "United States"
    );
};